// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { AvatarTokens } from './type';

const avatarTokens: AvatarTokens = {
  avatarWidth: 'Size-16',
  avatarHeight: 'Size-16',
  avatarBackgroundColor: 'Neutral-fill-3',
  avatarFontSize: 'font-14',
  avatarFontColor: 'Neutral-text-4',
  avatarFontWeight: 'Weight-medium',
  avatarSmallWidth: 'Size-12',
  avatarSmallHeight: 'Size-12',
  avatarSmallFontSize: 'font-12',
  avatarLargeWidth: 'Size-20',
  avatarLargeHeight: 'Size-20',
  avatarLargeFontSize: 'font-16',
  avatarCircleBorderRadius: 'Radius-circle',
  avatarMaxFontColor: 'Neutral-text-5',
  avatarMaxFontWeight: 'Weight-regular',
  avatarMaxHoverColor: 'Neutral-text-1',
  avatarMaxHoverBackgroundColor: 'Brand-6',
  avatarPopoverPadding: 'Spacing-16',
  avatarSquareBorderRadius: 'Radius-default',
  avatarGroupBorderWidth: 'Border-2',
  avatarGroupBorderColor: 'Neutral-fill-1',
  avatarGroupOffsetMargin: 'Spacing-8',
};

export default avatarTokens;
